import { ISymbolData } from '../../../parseToTree.types';
import { removeItemsByIndex } from '../utils/removeItemsByIndex';
import { IRemoveTagsWithoutContentOptions } from './removeTagsWithoutContent.types';
import { getIsOpenTag } from './utils/getIsOpenTag';
import { getPreviousIndex } from './utils/getPreviousIndex';

export const removeTagsWithoutContent = ({
  positions,
}: IRemoveTagsWithoutContentOptions): ISymbolData[] => {
  const indexesToRemove: number[] = [];

  // i = 1, because i = 0 doesn't have previous position
  for (let i = 1; i < positions.length; i++) {
    const previousIndex = getPreviousIndex(i, indexesToRemove);
    const isOpenTag = getIsOpenTag(i, indexesToRemove);

    const prevPosition = positions[previousIndex];
    const currentPosition = positions[i];

    // we don't need to try find content between close and open tags
    // but we need to remove cross tags "***1******2***"
    if (isOpenTag && prevPosition.end > currentPosition.start) {
      indexesToRemove.push(i);
    } else if (!isOpenTag && prevPosition.end >= currentPosition.start) {
      indexesToRemove.push(i);
    }
  }

  return removeItemsByIndex({
    list: positions,
    indexesToRemove,
  });
};
